var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextSlice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-circle-right",
    clipPath: "url(#clip0_709_117178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 0.625C30.7031 0.625 39.375 9.29688 39.375 20C39.375 30.7031 30.7031 39.375 20 39.375C9.29688 39.375 0.625 30.7031 0.625 20C0.625 9.29688 9.29688 0.625 20 0.625ZM17.7422 11.8438L23.6406 17.5H9.375C8.33594 17.5 7.5 18.3359 7.5 19.375V20.625C7.5 21.6641 8.33594 22.5 9.375 22.5H23.6406L17.7422 28.1562C16.9844 28.8828 16.9688 30.0938 17.7109 30.8359L18.5703 31.6875C19.3047 32.4219 20.4922 32.4219 21.2188 31.6875L31.5859 21.3281C32.3203 20.5938 32.3203 19.4062 31.5859 18.6797L21.2188 8.30469C20.4844 7.57031 19.2969 7.57031 18.5703 8.30469L17.7109 9.15625C16.9688 9.90625 16.9844 11.1172 17.7422 11.8438Z",
    fill: "#008060"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_117178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextSlice);
export default __webpack_public_path__ + "static/media/next_slice.1b9fe44c3107a01db398bc470a1bc7ae.svg";
export { ForwardRef as ReactComponent };